import { getUserLang } from '@/i18n/utils';

export const normalizePriceUsd = (price: number) => {
  const formatter = new Intl.NumberFormat(getUserLang().detectedValue, {
    style: 'decimal'
  }).format(price);
  return `${formatter} USD`;
};
